import React from 'react';
import _map from 'lodash/map';
import _toString from 'lodash/toString';
// Core components
import Timeline from 'components/core/timeline/Timeline';
// Models
import mScenario from 'models/scenario';
// Custom
import { deviceDataShape, installationLogScenarioLogActionDataShape } from 'constants/PropTypesShapes';
import ScenarioLogExecActionElementItem from './ScenarioLogExecActionElementItem';

const ScenarioLogActionItem = ({ action, device }) => {
  // Build array of all actions
  const actionsArray = mScenario.actionAndTreeToArray(action);

  // Now build timeline items
  const timelineItems = _map(actionsArray, (actionElement) => {
    const delaySeconds = actionElement.delay / 10;

    return {
      id: _toString(actionElement.id),
      label: `${delaySeconds} s`,
      iconId: 'tlEvent',
      content: <ScenarioLogExecActionElementItem action={actionElement} device={device} />,
    };
  });

  return (
    <div className="box box-dark m-0 mt-3">
      <Timeline
        startItem={{
          iconId: 'tlStart',
        }}
        items={timelineItems}
      />
    </div>
  );
};

ScenarioLogActionItem.propTypes = {
  action: installationLogScenarioLogActionDataShape.isRequired,
  device: deviceDataShape.isRequired,
};

module.exports = ScenarioLogActionItem;



// WEBPACK FOOTER //
// ./routes/app/routes/installations/assets/logs/ScenarioLogExecActionItem.js